import axios from 'axios';
import { httpResponse } from './api-response-status';
import apiClient from './setup';

const fetchProvinces = async () => {
  try {
    const response = await apiClient.get('/api/user/provinces');
    return httpResponse('SUCCESS', response.data);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return httpResponse('ERROR', error.response?.data);
    } else {
      return httpResponse('PANICO', error);
    }
  }
};

export const resources = {
  fetchProvinces,
};
